import React, { useState } from 'react';
import {
  HeaderContainer,
  Title,
  StyledInput,
  IconContainer,
  Search,
  Subtitle,
  Button,
  Row,
  ButtonTransparent,
  SearchIcon,
  StyledHeaderRow,
} from './Header.styles';
import { ReactComponent as LeftChevron } from '../../assets/icons/back.svg';
import { ReactComponent as Add } from '../../assets/icons/addBtn.svg';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';

const Header = ({
  title,
  search,
  searchValue,
  setSearchValue,
  back,
  onBack,
  buttonAdd,
  buttonText,
  secondButtonText,
  secondButtonAdd,
  onButtonClick,
  onSecondButtonClick,
  calendarButtons,
  subtitle,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <HeaderContainer>
      <StyledHeaderRow>
        <Row>
          {back && <LeftChevron onClick={onBack} className="icon-back" />}
          {title && <Title>{title}</Title>}
        </Row>

        <Row>
          {calendarButtons}

          {secondButtonAdd && (
            <ButtonTransparent onClick={onSecondButtonClick}>
              <Edit />
              {secondButtonText}
            </ButtonTransparent>
          )}

          {search && (
            <StyledInput>
              <IconContainer
                onClick={() => {
                  setOpen(!open);
                }}>
                <SearchIcon />
              </IconContainer>
              <Search
                placeholder={'Search...'}
                value={searchValue}
                onChange={setSearchValue}
                $open={open}
                disabled={!open}
              />
            </StyledInput>
          )}
          {buttonAdd && (
            <Button onClick={onButtonClick}>
              <Add />
              {buttonText}
            </Button>
          )}
        </Row>
      </StyledHeaderRow>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </HeaderContainer>
  );
};

export default Header;
